


































import { ElTable } from "element-ui/types/table";
import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { ExpressionKinds } from "../../../../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../../../../../../../formatEditor/domain/editableFormat";
import { CalculateObjectEditor } from "../../../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class CalculationConditionalExpressionObjectSelector extends Mixins() {
  @Prop({ default: "名称" })
  labelName: string;

  @Prop({ default: "ID" })
  labelId: string;

  @Prop({ default: () => [] as IFormatObjectEditable[] })
  selectionObjects: IFormatObjectEditable[];

  filteres: {
    enabled: boolean;
    name: string;
    description: string;
    filter: (v: IFormatObjectEditable) => boolean;
  }[] = [
    { enabled: false, name: "テキスト", description: "テキストで絞り込みします",
      filter: v => {
        switch (v.objectTypeName().getValue()) {
          case "text":
          case "tag":
          case "script":
          case "scriptlink":
          case "jointext":
            return true;
          default:
            return false;
        }
      }
    },
    { enabled: false, name: "チェック", description: "チェックで絞り込みします",
      filter: v => v.objectTypeName().getValue() === "check" },
    { enabled: false, name: "円選択", description: "円選択で絞り込みします",
      filter: v => v.objectTypeName().getValue() === "circleselect" },
    { enabled: false, name: "リスト", description: "リストで絞り込みします",
      filter: v => v.objectTypeName().getValue() === "combo" },
    { enabled: false, name: "クリック", description: "クリック選択で絞り込みします",
      filter: v => v.objectTypeName().getValue() === "roll" },
    { enabled: false, name: "計算", description: "計算式で絞り込みします",
      filter: v => v.objectTypeName().getValue() === "calculate" && v instanceof CalculateObjectEditor && v.kind().getValue() === ExpressionKinds.Calculation },
    { enabled: false, name: "期間日数", description: "期間日数で絞り込みします",
      filter: v => v.objectTypeName().getValue() === "calculate" && v instanceof CalculateObjectEditor && v.kind().getValue() === ExpressionKinds.DateDuration },
  ];

  $refs!: {
    table: ElTable,
  };

  get filteredObjects(): IFormatObjectEditable[] {
    return this.filteres.some(f => f.enabled)
      ? this.selectionObjects.filter(o => this.filteres.some(f => f.enabled && f.filter(o)))
      : this.selectionObjects;
  }

  toTypeName(row: IFormatObjectEditable): string {
    return row.getTypeName();
  }

  toIdentifiableName(row: IFormatObjectEditable): string {
    return row.getIdentifiableName()
      ? row.getIdentifiableName()
      : row.toLinkedObjectIdentifier().key;
  }

  toId(row: IFormatObjectEditable): string {
    return row.id().getValue().toString();
  }

  @Watch("selectionObjects")
  onSelectionObjectsUpdated(newValue: IFormatObjectEditable[], oldValue: IFormatObjectEditable[]) {
    this.filteres.forEach(f => f.enabled = false);

    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.table));
  }

  @Emit()
  currentChange(currentRow: IFormatObjectEditable, oldCurrentRow: IFormatObjectEditable): void {}
}
